import { Inventory2Rounded, LocalOfferRounded, StorefrontRounded } from '@mui/icons-material';
import BrokerQueuePage from '../components/BrokerQueuePage';
import server from '../../../services/server';

export default function LomadeeQueue() {
    return (
        <BrokerQueuePage
            broker="lomadee"
            title="Lomadee — fila de importação"
            subtitle="Importa marcas (anunciantes), campanhas e produtos (ofertas) via BullMQ. Campanhas/produtos só entram se a marca já tiver vínculo."
            fetchUrl="brokers/lomadee/queue/jobs"
            jobLabelMap={{
                'sync-brand': 'Marca',
                'sync-campaign': 'Campanha',
                'sync-product': 'Produto',
                'lomadee-sync-brand': 'Marca',
                'lomadee-sync-campaign': 'Campanha',
                'lomadee-sync-product': 'Produto',
            }}
            helpItems={[
                'Ordem recomendada: marcas → campanhas/produtos. Sem anunciante vinculado, ofertas são ignoradas no enqueue.',
                'Worker: concorrência 1 e limiter ~30 jobs/min. Cron noturna enfileira marcas; o gate dispara ofertas ao terminar.',
                'Cadastro manual por campanha/produto nas telas Social Soul continua disponível.',
            ]}
            actions={[
                {
                    key: 'brands',
                    step: '1',
                    title: 'Marcas',
                    description: 'Lista marcas na Lomadee e enfileira criação/vínculo de anunciante.',
                    buttonLabel: 'Enfileirar marcas',
                    variant: 'contained',
                    startIcon: <StorefrontRounded />,
                    request: () => server.post('brokers/lomadee/enqueue/brands', { limit: 100, maxPages: 50 }),
                    successMessage: d =>
                        `Marcas: ${d?.brandsSeen ?? '—'}. Na fila: ${d?.enqueued ?? 0}. Duplicados: ${d?.skippedDuplicates ?? 0}.`,
                },
                {
                    key: 'campaignsBulk',
                    step: '2a',
                    title: 'Campanhas → ofertas',
                    description: 'Enfileira campanhas cuja marca (organizationId) já tem anunciante vinculado.',
                    buttonLabel: 'Enfileirar campanhas',
                    variant: 'outlined',
                    startIcon: <LocalOfferRounded />,
                    request: () =>
                        server.post('brokers/lomadee/enqueue/campaigns/bulk', { limit: 50, maxPages: 20 }),
                    successMessage: d =>
                        `Campanhas: ${d?.campaignsSeen ?? '—'}. Na fila: ${d?.enqueued ?? 0}. Sem anunciante: ${d?.skippedNoAdvertiser ?? '—'}.`,
                },
                {
                    key: 'productsBulk',
                    step: '2b',
                    title: 'Produtos → ofertas',
                    description: 'Enfileira produtos como oferta quando a marca já está vinculada.',
                    buttonLabel: 'Enfileirar produtos',
                    variant: 'outlined',
                    color: 'secondary',
                    startIcon: <Inventory2Rounded />,
                    request: () =>
                        server.post('brokers/lomadee/enqueue/products/bulk', { limit: 50, maxPages: 20 }),
                    successMessage: d =>
                        `Produtos: ${d?.productsSeen ?? '—'}. Na fila: ${d?.enqueued ?? 0}. Sem anunciante: ${d?.skippedNoAdvertiser ?? '—'}.`,
                },
            ]}
        />
    );
}
